import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { equipmentService } from "../../Services/equipment.service";
import Spinner from "../Components/Spinner";

const ModalSearchEquipment = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [data, setData] = useState([]);

  const listModels = props.listModels || [];
  const listStatus = props.listStatus || [];

  const resolveName = (list, id) => list.find((item) => String(item.id) === String(id))?.name ?? id;

  const handleClose = () => props.handleClose(!props.show);

  const handleSelect = async (item) => {
    setTimeout(() => {
      props.handleSelect(item);
    }, 500);
  };

  useEffect(() => {
    (async () => {
      if (!props.show) return;

      const { equipmentModelId, equipmentStatusId, serial, address } = props.filter || {};

      if (!equipmentModelId && !equipmentStatusId && !serial && !address) return;

      const badges = [];
      if (equipmentModelId) badges.push(`Modelo: ${resolveName(listModels, equipmentModelId)}`);
      if (equipmentStatusId) badges.push(`Status: ${resolveName(listStatus, equipmentStatusId)}`);
      if (serial) badges.push(`Serial: ${serial}`);
      if (address) badges.push(`Endereço: ${address}`);

      setFilterName(
        <>
          {badges.map((badge, index) => (
            <span key={index} className='badge bg-label-primary me-1'>
              {badge}
            </span>
          ))}
        </>
      );

      setIsLoading(true);
      try {
        const response = await equipmentService.fetchEquipment({
          equipmentModelId,
          equipmentStatusId,
          serialNumber: serial,
          address,
        });
        setData(Array.isArray(response) ? response : response ? [response] : []);
      } catch (error) {
        setData([]);
      } finally {
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, props.filter]);

  return (
    <>
      <Modal
        id='modalChips'
        show={props.show}
        backdrop='static'
        size='lg'
        fullscreen='true'
        onHide={handleClose}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar Equipamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <>
              <h5>Buscando...</h5>
              <Spinner />
            </>
          ) : (
            <>
              {data && data?.length > 0 ? (
                <>
                  <div className='card'>
                    <h5 className='card-header'>{filterName}</h5>
                    <div className='card-body'>
                      <table className='table table-bordered'>
                        <thead>
                          <tr>
                            <th>Serial</th>
                            <th>Endereço</th>
                            <th>Modelo</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data &&
                            data.map((item, index) => (
                              <tr
                                key={index}
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSelect(item)}>
                                <td>{item.serialNumber ?? item.SerialNumber}</td>
                                <td>{item.address ?? item.Address}</td>
                                <td>
                                  {resolveName(
                                    listModels,
                                    item.equipmentModelId ?? item.EquipmentModelId
                                  )}
                                </td>
                                <td>
                                  {resolveName(
                                    listStatus,
                                    item.equipmentStatusId ?? item.EquipmentStatusId
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h5>
                    😅Sem registros encontrados para este filtro. Mude seu
                    filtro e tente novamente!
                  </h5>
                </>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalSearchEquipment;
